import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]

import { computed, onMounted, watch } from 'vue'
import type { Component } from 'vue'
import { useRoute } from 'vue-router'

import PATHS from '@/router/paths'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'

import HandoverApprovals from '../HandoverApprovals/Index.vue'
import AuditoriumExceptionalities from '../AuditoriumExceptionalities/index.vue'
import DsAttendance from '../DsAttendance/Index.vue'
import CheckValidation from '../CheckValidation/Index.vue'
import FacialBiometry from '../FacialBiometry/Index.vue'
import PriorityPayments from '../PriorityPayments/Index.vue'
import { findApprovalsQueue, isApprovalsQueueKey } from './queues'
import type { ApprovalsQueueKey } from './queues'

// Mesmo mapa slot→componente do antigo shell de abas (ApprovalsTabs.vue).

export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalsQueuePage',
  setup(__props) {

const QUEUE_COMPONENTS: Record<ApprovalsQueueKey, Component> = {
  handoverApprovals: HandoverApprovals,
  exceptionality: AuditoriumExceptionalities,
  attendance: DsAttendance,
  checkValidation: CheckValidation,
  facialBiometry: FacialBiometry,
  priorityPayments: PriorityPayments
}

const route = useRoute()
const headerStore = useHeaderStore()

const queueKey = computed<ApprovalsQueueKey>(() => {
  const key = route.meta.approvalsQueue
  return isApprovalsQueueKey(key) ? key : 'exceptionality'
})

const queue = computed(() => findApprovalsQueue(queueKey.value))

const breadcrumb = { label: 'Aprovações', route: PATHS.APPROVALS }

// Header da fila (com breadcrumb). Aplicado no mount da página, na troca de
// fila e após o mount do módulo (ver `@vue:mounted` no template).
const applyHeader = () =>
  headerStore.setTitle(queue.value.pageTitle, queue.value.pageDescription, breadcrumb)

onMounted(applyHeader)
watch(queueKey, applyHeader)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full flex flex-col gap-6 text-left",
    "data-testid": `approvals-queue-${queue.value.key}`
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(QUEUE_COMPONENTS[queue.value.key]), {
      key: queue.value.key,
      onVnodeMounted: applyHeader
    }))
  ], 8, _hoisted_1))
}
}

})